import { LEGAL_PAGES, type LegalPage } from '../legal.js'

/**
 * A legal document.
 *
 * The markdown is ours, written and reviewed in the repository, so rendering
 * it as HTML is safe -- no user content reaches this path.
 */
export function Legal({ page }: { readonly page: LegalPage }) {
  return (
    <div className="doc-wrap">
      <nav className="doc-nav">
        <a className="doc-home" href="/">simplelaunch<span>.</span></a>
        {LEGAL_PAGES.map((p) => (
          <a key={p.slug} href={`/${p.slug}`} aria-current={p.slug === page.slug ? 'page' : undefined}>
            {p.title}
          </a>
        ))}
      </nav>
      <article className="doc" dangerouslySetInnerHTML={{ __html: page.html }} />
    </div>
  )
}
